/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OsisRuleBulkUpdateRequest
 */
export interface OsisRuleBulkUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleBulkUpdateRequest
     */
    ids?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleBulkUpdateRequest
     */
    osis?: Array<string> | null;
}

export function OsisRuleBulkUpdateRequestFromJSON(json: any): OsisRuleBulkUpdateRequest {
    return OsisRuleBulkUpdateRequestFromJSONTyped(json, false);
}

export function OsisRuleBulkUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleBulkUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ids': !exists(json, 'ids') ? undefined : json['ids'],
        'osis': !exists(json, 'osis') ? undefined : json['osis'],
    };
}

export function OsisRuleBulkUpdateRequestToJSON(value?: OsisRuleBulkUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ids': value.ids,
        'osis': value.osis,
    };
}


